import gql from 'graphql-tag'

export const pendingApplicationsQuery = gql`
  query ($orderBy: ApplicationOrderByInput, $first: Int, $after: ID) {
    pendingApplications(orderBy: $orderBy, first: $first, after: $after) {
      id
      name
      email
      createdAt
    }
  }
`
export const deactivatedTrainersQuery = gql`
  query {
    deactivatedTrainers {
      id
      name
      email
      createdAt
      totalEarnings
      pendingEarnings
    }
  }
`
export const trainersQuery = gql`
  query {
    trainers {
      id
      name
      email
      createdAt
      totalEarnings
      pendingEarnings
      user {
        id
      }
      stripeConnectCode
    }
  }
`

export const approvedApplicationsQuery = gql`
  query ($orderBy: ApplicationOrderByInput, $first: Int, $after: ID) {
    approvedApplications(orderBy: $orderBy, first: $first, after: $after) {
      id
      name
      email
      createdAt
    }
  }
`
export const trainerQuery = gql`
  query ($id: ID!) {
    trainer(id: $id) {
      id
      createdAt
      updatedAt
      name
      email
      phone
      address
      city
      state
      zipCode
      photo
      video
      instagram
      certifications
      specialties
      bio
      virtualCoachingRate
      offlineCoachingRate
      deactivatedAt
      reviews {
        id
        createdAt
        updatedAt
        user {
          id
          name
        }
        trainer {
          id
          name
        }
        rating
        comment
      }
      trainerNotes {
        id
        createdAt
        updatedAt
        trainer {
          id
          name
        }
        user{
          id
          email
          name
          cognitoUsername
        }
        note
      }
      user {
        id
      }
    }
  }
`
export const trainerNoteQuery = gql`
  query ($id: ID!) {
    trainerNote (id: $id) {
      id
      createdAt
      updatedAt
      application
      user {
        id 
        name
      }
      note
    }
  }
`
export const createTrainerNoteMutation = gql`
  mutation($trainerId: ID!, $note: String!) {
    createTrainerNote(trainerId: $trainerId, note: $note) {
      note
      user{
        id
      }
    }
  }
`
export const createTrainerMutation = gql`
  mutation($data: TrainerCreateInput!) {
    createTrainer(data: $data) {
      id
    }
  }
`
export const updateTrainerMutation = gql`
  mutation($id: ID!, $data: TrainerUpdateInput!) {
    updateTrainer(id: $id, data: $data) {
      id
    }
  }
`
export const deactivateTrainerMutation = gql`
  mutation ($id: ID!) {
    deactivateTrainer(id: $id) {
      id
    }
  }
`

export const stripeConnectUrlQuery = gql`
  query {
    stripeConnectUrl
  }
`
